import type { ThemeButton } from '@libs/themes';

export type CustomButtonEventPayload = ThemeButton;

export enum ButtonMode {
    light = 0,
    dark = 1,
}
